import { ROLE_PLATFORM_HIXME_ADMIN } from '@hixme/role-policy'
import Settings from './Settings'
import authOnEnter from 'enrollment-platform/authOnEnter'
import AdminPortalGate from 'enrollment-platform/rbac/AdminPortalGate'
import { abilityOnEnter } from 'enrollment-platform/rbac/abilityOnEnter'
import { RbacActions, RbacSubjects } from 'enrollment-platform/rbac/constants'

const SettingsRoutes = {
  path: '/settings',
  component: AdminPortalGate,
  onEnter(_nextState, replace, callback) {
    // Role check first (existing), then DB ability: Read on Settings.
    authOnEnter({
      allowedRoles: [ROLE_PLATFORM_HIXME_ADMIN],
      callback: (err?: { status: number; message: string }) =>
        err
          ? callback(err)
          : abilityOnEnter({
              action: RbacActions.Read,
              subject: RbacSubjects.Settings,
              replace,
              callback,
            }),
    })
  },
  indexRoute: {
    component: Settings,
  },
}

export default SettingsRoutes
